import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-6 col-12" }
const _hoisted_6 = { class: "d-flex flex-row" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-0 mr-3" }, "Appointments", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, "Refresh data", -1)
const _hoisted_9 = { class: "col-lg-6 col-12" }
const _hoisted_10 = { class: "d-flex justify-content-end mb--4" }
const _hoisted_11 = { class: "" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "Aqui va el form")
], -1)

import { computed, onMounted, ref } from "vue";
import { AlertModule } from "@/store/modules/Alert";
import { iInvalidSubmit } from "@/composables/vee-validate";
import { Form, FormActions, Field } from "vee-validate";
import { Plus, Refresh } from "@element-plus/icons";
import BaseInput from "@/components/Inputs/BaseInput.vue";
import Table from "@/components/TablePaginated.vue";
import { IColumn } from "@/types/components";
import { QueueManagementAPI, coreApi } from "@/conection/index";
import * as yup from "yup";
import { IPagination } from "@/callcenter/omni";
import { ITablePagination } from "@/types/components";
import { IndexType } from "@/types/store";
import { DateTime } from "ts-luxon";
import swal from "sweetalert2";
import { ElLoading } from "element-plus";

import Modal from "@/components/Modal.vue";
import { formatComputedDate } from "@/util/utils";
import { response } from "express";
interface ITemplates {
	statusType: "confirmation" | "follow-up";
	templateId: string;
	channelId: string;
	accountId: string;
	id: number;
}
interface IAppointment {
	appointmentDate: string;
	createdAt: Date | string;
	updatedAt: Date | string;
	id: number;
	notes: string;
	patient: string;
	reason: string;
	status: string;
	patientPhoneNumber: string;
}
enum sendType {
	CALL = "call",
	SMS = "sms",
	WA = "wha",
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let templates: ITemplates[];
const formkey = ref(0);
const formComponent = ref<
	| (FormActions<any> & {
			getValues: () => { [k: string]: string | undefined };
	  })
	| null
>(null);
const loadingCall = ref(false);
const loadingTable = ref(false);

const pagination = {
	perPage: 6,
	currentPage: 1,
	perPageOptions: [6, 10, 25, 50],
	total: 0,
};
const startOfDay = new Date();
startOfDay.setHours(0, 0, 0, 0); // Sets to 00:00:00.000

// Get the end of the day
const endOfDay = new Date();
endOfDay.setHours(23, 59, 59, 999); // Sets to 23:59:59.999

const model = ref({
	modal: false,
	pagination,
	initdate: formatComputedDate(startOfDay),
	finalDate: formatComputedDate(endOfDay),
});
const td = ref<IAppointment[]>([]);
const th: IColumn[] = [
	{
		text: "Code",
		value: "id",
		width: 110,
	},
	{
		text: "Appointment Date",
		value: "appointmentDate",
		width: 260,
	},
	{
		text: "Status",
		value: "status",
		width: 150,
		tag: true,
		tagFormat: {
			scheduled: "primary",
			confirmation: "success",
			"follow-up": "info",
			completed: "warning",
			canceled: "danger",
		},
	},
	{
		text: "Patient",
		value: "patient",
		width: 250,
	},
	{
		text: "Duration Min",
		value: "durationMinutes",
		width: 170,
	},
	{
		text: "Notes",
		value: "notes",
		width: 200,
	},
	{
		text: "Reason",
		value: "reason",
		width: 200,

	},

	{
		text: "Created",
		value: "createdAt",
		width: 260,
	},
];
const paginate = ref<ITablePagination | undefined>({
	currentPage: 1,
	perPage: 5,
	perPageOptions: [5, 10, 15, 20],
	total: 0,
});
//schema
const schema = yup.object({
	message: yup
		.string()
		.matches(
			/^[\w\s\p{P}\p{S}]+$/u,
			"Message is not valid, It should not contain accents."
		)
		.required("Message is required"),
	number1: yup.string().matches(/^\d{3,}$/, "Phone number 1 is not valid"),
});

function onInvalidSubmit(values: iInvalidSubmit) {
	console.log(values);

	const errMsgs: string[] = Object.keys(values.errors);

	AlertModule.SOCKET_PUSH_NOTIFICATION({
		text: `Please Check ${errMsgs.join()}`,
		type: "error",
	});
}
async function fetchData(pag?: IPagination) {
	loadingTable.value = true;
	try {
		const IDate = new Date(model.value.initdate);
		const FDate = new Date(model.value.finalDate);

		const response = await QueueManagementAPI.post<{
			docs: IAppointment[];
			limit: number;
			page: number;
			totalDocs: number;
			totalPages: number;
			value: boolean;
		}>("/appointment/by/dates", {
			page: pag?.page,
			limit: pag?.limit,
			initDate: IDate.toISOString(),
			finalDate: FDate.toISOString(),
		});
		td.value = response.data?.docs?.map(item => {
			const dateObject = DateTime.fromISO(item.createdAt + "");
			const dateObjectA = DateTime.fromISO(item.appointmentDate + "");

			return {
				...item,
				createdAt: dateObject.toLocaleString(DateTime.DATETIME_FULL, {
					locale: "en-gb",
				}),
				appointmentDate: dateObjectA.toLocaleString(DateTime.DATETIME_FULL, {
					locale: "en-gb",
				}),
			};
		});

		paginate.value = {
			currentPage: Number(pag?.page),
			perPage: Number(pag?.limit),
			perPageOptions: [5, 10, 15, 20],
			total: response.data?.totalPages,
		};
		if (response.status === 201) {
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: `Get data`,
				type: "success",
			});
		} else {
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: `Error// Cannot get data`,
				type: "error",
			});
		}
	} catch (error) {
		console.log(error);
		AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: `Error// Cannot get data`,
			type: "error",
		});
	}

	loadingTable.value = false;
}
async function sendMessage2Whatsapp(
	params: IAppointment,
	type = "confirmation"
) {
	const loading = ElLoading.service({
		lock: true,
		text: "Sending message",
	});
	try {
		const confirm = templates.find(x => x.statusType == type);
		const patientName = params.patient.split(" ");
		const response = await coreApi.post("/api/message/sendForUsers", {
			first_name: patientName[0], // String - Primer nombre del paciente
			second_name: patientName[1], // String - Segundo nombre del paciente
			third_name: "", //String - Tercer nombre del paciente, dejar vacío si no se tiene
			last_name: patientName[2], // String - Primer apellido
			last_name2: patientName[3], // String - Segundo apellido
			phone: params.patientPhoneNumber,

			...confirm,
			templateBody: {
				"1": params.appointmentDate,
				"2": "https://demo-admin.dms-smart.cloud/meeting/index.php?3f1b7ccad63d40a7b4c27dda225bf941",
			},
			accountId: "66d37c06fc54ec0025f0ecfd",
			customEvent: {
				name: type === "confirmation"
					? "CONFIRMATION"
					: "FOLLOWUP",
				params: {
					"appointment-id": params.id,
				}
			} 
		});
		if (response.status === 200) {
			// await QueueManagementAPI.post("/appointment/updateStatus", {
			// 	id: params.id,
			// 	status: type,
			// });
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: response.data?.message,
				type: "success",
			});
			swal.fire({
				title: "Message response",
				text: response.data?.message,
				icon: "success",
			});
			loading.close();
			// await fetchData({ page: 1, limit: 5 });
		} else {
			loading.close();
			swal.fire({
				title: "Message response",
				text: response.data?.message,
				icon: "error",
			});
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: response.data?.message,
				type: "error",
			});
		}
	} catch (error: any) {
		loading.close();
		AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: `Error// Cannot send messages`,
			type: "error",
		});
	}
}

onMounted(async () => {
	await fetchData({ page: 1, limit: 5 });
	templates = (await QueueManagementAPI.get("/templates")).data;
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_card = _resolveComponent("card")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_card, { "header-classes": "bg-transparent" }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createVNode(_component_el_popover, {
                      ref: "popoverRef",
                      placement: "top-start",
                      width: 200,
                      trigger: "hover",
                      "show-after": 10,
                      triggerKeys: [],
                      class: "mr-3"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      reference: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          onClick: _cache[0] || (_cache[0] = 
														async () => {
															await fetchData({ page: 1, limit: 5 });
														}
													),
                          icon: _unref(Refresh),
                          "native-type": "submit",
                          circle: "",
                          type: "info"
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 512)
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(BaseInput, {
                      type: "datetime-local",
                      name: "initDate",
                      "label-classes": "text-muted h5 font-weight-normal",
                      alternative: "",
                      inputGroupClasses: "w-100",
                      value: _unref(formatComputedDate)(_unref(startOfDay)),
                      onChangeInput: _cache[1] || (_cache[1] = 
												async (e) => {
													model.value.initdate = e;
													await fetchData({ page: 1, limit: 5 });
												}
											)
                    }, null, 8, ["value"]),
                    _createVNode(BaseInput, {
                      type: "datetime-local",
                      name: "initDate",
                      "label-classes": "text-muted h5 font-weight-normal",
                      alternative: "",
                      inputGroupClasses: "w-100",
                      class: "ml-3",
                      value: _unref(formatComputedDate)(_unref(endOfDay)),
                      onChangeInput: _cache[2] || (_cache[2] = 
												async (e) => {
													model.value.finalDate = e;
													await fetchData({ page: 1, limit: 5 });
												}
											)
                    }, null, 8, ["value"])
                  ])
                ])
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(Table, {
                  class: "mt--4 p-0",
                  "card-class": "shadow-none rounded",
                  tableData: { td: td.value, th: th, totalDocs: 0 },
                  tittle: "Appointments",
                  tittlebtn: "Actualizar",
                  load: loadingTable.value,
                  "show-options": true,
                  "show-campaign-options": true,
                  "hide-default-options": true,
                  disabled: false,
                  btn: false,
                  filter: false,
                  pagination: paginate.value,
                  onUpdateData: _cache[3] || (_cache[3] = ({ pagination }) => fetchData(pagination)),
                  onUpdateInputData: _cache[4] || (_cache[4] = ({ pagination }) => fetchData(pagination)),
                  onSendConfirmation: _cache[5] || (_cache[5] = 
									e => {
										sendMessage2Whatsapp(e, 'confirmation');
									}
								),
                  onSendFollowUp: _cache[6] || (_cache[6] = e => sendMessage2Whatsapp(e, 'follow-up'))
                }, null, 8, ["tableData", "load", "pagination"])
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: model.value.modal,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((model.value.modal) = $event)),
      "show-close": false,
      width: "60%"
    }, {
      default: _withCtx(() => [
        _hoisted_12
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})